import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import localStorage from "@/utils/localStorage";
Vue.use(Router);
import { general } from "@/api/expert.js";

const routes = [
  {
    path: "/",
    redirect: (to) => {
      if (!localStorage.get("role")) {
        general({
          url: "/smartfox/associationExpertApi/openidGetUserType",
          urlParams: ``,
          bodyJson: "",
          httpType: "GET",
        }).then((res) => {
          localStorage.set("role", res.data);
        });
      }
      let role = localStorage.get("role");
      let realRole = "";
      if (role) {
        realRole = role.toString().replaceAll('"', "");
      }
      if (realRole == "OPENID_BIND_TYPE_EXPERT") {
        return "/home";
      } else if (realRole == "OPENID_BIND_TYPE_WYXH") {
        return "/associationHome";
      } else {
        return "/roleChoices";
      }
    },
    // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要授权requireAuth设为true，
    meta: {
      index: 1,
    },
  },
  {
    path: "/login", // 登录页面
    name: "login",
    component: () => import("@/views/login/login.vue"),
    meta: {
      index: 1,
    },
  },
  {
    path: "/loginAuthorization", // 微信授权
    name: "loginAuthorization",
    component: () => import("@/views/login/login-authorization.vue"),
    meta: {
      index: 0,
    },
  },
  {
    path: "/home", // 首页
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      keepAlive: true,
      showTabBar: true,
      requireAuth: true,
      index: 1,
    },
  },
  {
    path: "/employ", // 续聘
    name: "employ",
    component: () => import("@/views/employ/index.vue"),
    meta: {
      keepAlive: false,
      showTabBar: true,
      requireAuth: true,
      index: 2,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/mine", // 我的
    name: "mine",
    component: () => import("@/views/mine/index.vue"),
    meta: {
      keepAlive: true,
      showTabBar: true,
      requireAuth: true,
      index: 3,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/personDetail", // 个人信息修改
    name: "personDetail",
    component: () => import("@/views/mine/personDetail.vue"),
    meta: {
      keepAlive: false,
      showTabBar: true,
      requireAuth: true,
      index: 3,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  // 免登录
  {
    path: "/personlist", // 人才
    name: "personlist",
    component: () => import("@/views/nologin/personlist.vue"),
    meta: {
      title:"惠州市物业服务行业专业人才证书",
      keepAlive: false,
      showTabBar: false,
      requireAuth: true,
      index: 6,
    },
  },
  // 免登录
  {
    path: "/specialist", // 专家
    name: "specialist",
    component: () => import("@/views/nologin/specialist.vue"),
    meta: {
      title:"惠州市物业服务行业专家证书",
      keepAlive: false,
      showTabBar: false,
      requireAuth: true,
      index: 6,
    },
  },
  //证书
  {
    path: "/certificateDetail", // 证书
    name: "certificateDetail",
    component: () => import("@/views/certificate/certificateDetail.vue"),
    meta: {
      title: "证书",
      keepAlive: false,
      showTabBar: true,
      requireAuth: true,
      index: 7,
    },
  },
  {
    path: "/editExpertInfo", // 我的
    name: "editExpertInfo",
    component: () => import("@/views/mine/edit-expert-info.vue"),
    meta: {
      keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/projectDetails", // 项目详情
    name: "projectDetails",
    component: () => import("@/views/project-details/index.vue"),
    meta: {
      keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      index: 2,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/myWorkLog", // 我的工作日志
    name: "myWorkLog",
    component: () => import("@/views/project-details/my-work-log.vue"),
    meta: {
      keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      index: 3,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/workLog", // 工作日志
    name: "workLog",
    component: () => import("@/views/project-details/work-log.vue"),
    meta: {
      keepAlive: true,
      index: 3,
      permission: "OPENID_BIND_TYPE_EXPERT",
      // showTabBar: true,
      //requireAuth: true,
    },
  },
  {
    path: "/expertMember", // 随行专家选择
    name: "expertMember",
    component: () => import("@/views/project-details/expert-member.vue"),
    meta: {
      keepAlive: true,
      index: 3,
      permission: "OPENID_BIND_TYPE_EXPERT",
      // showTabBar: true,
      //requireAuth: true,
    },
  },
  {
    path: "/auditLog", // 专家日志审核记录
    name: "auditLog",
    component: () => import("@/views/project-details/audit-log.vue"),
    meta: {
      keepAlive: true,
      index: 3,
      permission: "OPENID_BIND_TYPE_EXPERT",
      // showTabBar: true,
      //requireAuth: true,
    },
  },
  {
    path: "/reasonForLeave", // 请假理由
    name: "reasonForLeave",
    component: () => import("@/views/project-details/reason-for-leave.vue"),
    meta: {
      keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      index: 3,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/checkWorkLog", // 查看工作日志
    name: "checkWorkLog",
    component: () => import("@/views/project-details/check-work-log.vue"),
    meta: {
      showTabBar: false,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
      // keepAlive: true,
    },
  },
  {
    path: "/togetherWorkLog", // 工作日随行专家工作日志
    name: "togetherWorkLog",
    component: () => import("@/views/project-details/together-work-log.vue"),
    meta: {
      showTabBar: false,
      requireAuth: true,
      index: 5,
      permission: "OPENID_BIND_TYPE_EXPERT",
      // keepAlive: true,
    },
  },
  {
    path: "/personalBasicInfo", // 编辑个人信息
    name: "personalBasicInfo",
    component: () => import("@/views/mine/personal-basic-info.vue"),
    meta: {
      showTabBar: false,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
      // keepAlive: true,
    },
  },
  {
    path: "/editExpertInfo", // 编辑专家信息
    name: "editExpertInfo",
    component: () => import("@/views/mine/edit-expert-info.vue"),
    meta: {
      showTabBar: false,
      requireAuth: true,
      keepAlive: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/technologySpecialty", // 编辑专业技术特长
    name: "technologySpecialty",
    component: () => import("@/views/mine/technology-specialty.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: true,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/editEductionCertificate", // 编辑学历证书
    name: "editEductionCertificate",
    component: () => import("@/views/mine/edit-eduction-certificate.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/editCertificate", // 编辑职业证书
    name: "editCertificate",
    component: () => import("@/views/mine/edit-certificate.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/workExperience", // 编辑职业证书
    name: "workExperience",
    component: () => import("@/views/mine/work-experience.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/jobTitle", // 编辑职称
    name: "jobTitle",
    component: () => import("@/views/mine/job-title.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/paper", // 编辑论文
    name: "paper",
    component: () => import("@/views/mine/paper.vue"),
    meta: {
      // keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/workContent", // 编辑论文
    name: "workContent",
    component: () => import("@/views/mine/work-content.vue"),
    meta: {
      // keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/workResult", // 工作报告
    name: "workResult",
    component: () => import("@/views/mine/work-result.vue"),
    meta: {
      // keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/identify", // 身份证等附件信息
    name: "identify",
    component: () => import("@/views/mine/identify.vue"),
    meta: {
      // keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      index: 4,
      permission: "OPENID_BIND_TYPE_EXPERT",
    },
  },
  {
    path: "/roleChoices", // 登录人员类型选择
    name: "roleChoices",
    component: () => import("@/views/login/role-choices.vue"),
    meta: {
      // keepAlive: true,
      // showTabBar: true,
    },
  },
  {
    path: "/associationDetails", // 协会的详情页面
    name: "associationDetails",
    component: () => import("@/views/project-details/association-details.vue"),
    meta: {
      // keepAlive: true,
      // showTabBar: true,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/approvalTask", // 审批任务列表
    name: "approvalTask",
    component: () => import("@/views/approval/approval-task.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: true,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/approval", // 审批
    name: "approval",
    component: () => import("@/views/approval/approval.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/approvalEmploy", // 续聘审批
    name: "approvalEmploy",
    component: () => import("@/views/approval/approvalEmploy.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/approvalMine", // 审批的个人信息
    name: "approvalMine",
    component: () => import("@/views/approval/approval-mine.vue"),
    meta: {
      keepAlive: false,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/approvalMineEmploy", // 审批的续聘个人信息
    name: "approvalMineEmploy",
    component: () => import("@/views/approval/approvalMineEmploy.vue"),
    meta: {
      keepAlive: false,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/approvalPerson", // 审批的我的信息相关
    name: "approvalPerson",
    component: () => import("@/views/approval/approval-person.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/approvalPerson", // 审批的我的信息相关
    name: "approvalPerson",
    component: () => import("@/views/approval/approval-person.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/checkEduction", // 审批的我的学历
    name: "checkEduction",
    component: () => import("@/views/approval/check-eduction.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/checkCertificate", // 审批的我的职业证书
    name: "checkCertificate",
    component: () => import("@/views/approval/check-certificate.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/checkExperience", // 审批的我的工作经历
    name: "checkExperience",
    component: () => import("@/views/approval/check-experience.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/checkPaper", // 审批的我的论文
    name: "checkPaper",
    component: () => import("@/views/approval/check-paper.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/checkJobTitle", // 审批的我的职称
    name: "checkJobTitle",
    component: () => import("@/views/approval/check-job-title.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/checkFile", // 审批的我的职称
    name: "checkFile",
    component: () => import("@/views/approval/check-file.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: false,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/associationHome", // 协会首页
    name: "associationHome",
    component: () => import("@/views/home/association-home.vue"),
    meta: {
      // keepAlive: true,
      showTabBar: true,
      requireAuth: true,
      permission: "OPENID_BIND_TYPE_WYXH",
    },
  },
  {
    path: "/404", // 404
    name: "404",
    component: () => import("@/views/common/404.vue"),
    meta: {
      showTabBar: false,
    },
  },
];

const router = new Router({
  routes,
  mode: "hash",
});

router.beforeEach((to, from, next) => {
  console.log("to", to);
  console.log("from", from);
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 判断要去的路由有没有requiresAuth
  if (to.matched.some((r) => r.meta.requireAuth)) {
    if (localStorage.get("token")) {
      // next(); //有token,进行request请求
      if (to.meta.permission) {
        let role = localStorage.get("role");
        let realRole = "";
        if (role) {
          realRole = role.toString().replaceAll('"', "");
        }
        realRole === to.meta.permission ? next() : next({ path: "/404" });
      } else {

        next();
      }
    } else {
      // if(to.meta.title){
      //   document.title = to.meta.title
      // }
      if (to.path.indexOf('/personlist') != -1){
        next()
      } else if (to.path.indexOf('/specialist') != -1){
        next()
      }else{
        next({
          path: "/loginAuthorization",
          // 将刚刚要去的路由path（却无权限）作为参数，方便登录成功后直接跳转到该路由，这要进一步在登陆页面判断
          // query: { redirect: to.fullPath },
        });
      }

    }
  } else {
    next(); //如果无需token,那随它
  }
});
export default router;
